export default __webpack_public_path__ + "static/media/django.da80333a.png";